var cilWindow = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M424,440V48H88V440H48v32H464V440ZM120,80H240V200H120Zm0,152H240V376H120ZM392,440H120V408H392Zm0-64H272V232H392Zm0-176H272V80H392Z' class='ci-primary'/>"];

export { cilWindow };
//# sourceMappingURL=cil-window.js.map
